import { Link, useNavigate } from "react-router";
import { api } from "@/lib/api";
import { useQuery } from "@/lib/useQuery";
import type { AccountDetail, Quote, Invoice, Payment } from "@/lib/types";
import { money, shortDate, titleCase } from "@/lib/format";
import { Button, Card, Loading, Empty, Tag } from "@/components/ui";
import { useMe } from "@/app/MeContext";
import { BillingPanel } from "@/pages/billing/BillingPanel";

export function QuotesBillingTab({ account }: { account: AccountDetail }) {
  const me = useMe();
  const nav = useNavigate();
  const { data, loading } = useQuery<Quote[]>(me.permissions.seePricing ? `quotes:acct:${account.id}` : null, () => api.get<Quote[]>(`/quotes?accountId=${account.id}`), [account.id]);
  return (
    <div className="two-col">
      <div className="left">
        {me.permissions.seePricing ? (
          <Card title="Quotes" actions={me.permissions.sendQuotes && <Button size="md" variant="primary" onClick={() => nav(`/quotes?new=${account.id}`)}>New quote</Button>}>
            {loading && !data ? <Loading /> : (data ?? []).length === 0 ? <Empty>No quotes yet.</Empty> : (
              <table className="table">
                <thead><tr><th>Quote</th><th>Title</th><th>Upfront</th><th>Monthly</th><th>Status</th><th>Sent</th></tr></thead>
                <tbody>{(data ?? []).map((q) => <tr key={q.id} className="click" onClick={() => nav(`/quotes/${q.id}`)}><td className="num">{q.number} <span className="xs muted">v{q.version}</span></td><td className="muted-2">{q.title}</td><td className="num">{money(q.upfrontTotal)}</td><td className="num">{money(q.monthlyTotal)}/mo</td><td><Tag color={q.status === "accepted" ? "green" : q.status === "viewed" ? "accent" : q.status === "declined" ? "red" : "outline"}>{titleCase(q.status)}</Tag></td><td className="muted small">{shortDate(q.sentAt)}</td></tr>)}</tbody>
              </table>
            )}
          </Card>
        ) : <Card><Empty>Pricing is hidden for your role.</Empty></Card>}
      </div>
      <div className="right">
        {me.permissions.seeInvoices ? <BillingPanel accountId={account.id} /> : <Card><Empty>Invoices are hidden for your role.</Empty></Card>}
      </div>
    </div>
  );
}

export type { Invoice, Payment };
export { Link };
